import katex from 'katex'
import 'katex/dist/katex.min.css'
import Quill from 'quill'
import 'quill/dist/quill.snow.css'

import { isStringifiedQuillDelta } from './isStringifiedQuillDelta'

;(window as any).katex = katex

export function convertDeltaToHtml(value?: string): string {
  if (!value) return ''

  if (isStringifiedQuillDelta(value)) {
    const container = document.createElement('div')

    const quill = new Quill(container, {
      theme: 'snow',
      readOnly: true,
      modules: { toolbar: false },
    })

    quill.setContents(JSON.parse(value))

    return container.querySelector('.ql-editor')?.innerHTML ?? ''
  } else {
    return value
  }
}
